import type { Option } from '@branchjs/neo-components';
import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateChannel = new ReduxAsyncAction<'UPDATE_CHANNEL', Option, { channel: Option }>('UPDATE_CHANNEL');

UpdateChannel.registerRequest(async (channel: Option) => {
  return { channel };
});

export const UPDATE_CHANNEL = UpdateChannel.actionNamespaceConstants;
export const updateChannel = UpdateChannel.request;

export type UpdateChannelResponseAction = Action<typeof UPDATE_CHANNEL.response> & {
  data: { channel: Option };
};
